import React from "react";
import "./FlightRoute.css";
import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
export default function FlightRouteCard({ flight, handleViewMore,viewMore=true }) {
  if (!flight) return null;

  const {
    carrier_code,
    carrier_name,
    flight_number,
    status,
    departure_airport,
    arrival_airport,
    departure_time,
    estimated_arrival,
    actual_arrival,
    arrival_time,
    departure_terminal,
    arrival_terminal,
    aircraft_name,
    flight_equipment_iata,
    departure_city,
    departure_country,
    arrival_city,
    arrival_country,
    region,
  } = flight;

  const fmt = (dt) => new Date(dt).toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  const arrivalStatus = (() => {
    if (!estimated_arrival || !arrival_time) return null;
    const diff =
      new Date(estimated_arrival).getTime() - new Date(arrival_time).getTime();
    const min = Math.round(diff / 60000);
    if (min < 0) return `${Math.abs(min)} min late`;
    if (min > 0) return `${min} min early`;
    return "On time";
  })();


  function getFlightStatus(code) {
  switch (code) {
    case "A":
      return "Active (in flight)";
    case "C":
      return "Canceled";
    case "D":
      return "Diverted";
    case "DN":
      return "Data Needed / Not Available";
    case "L":
      return "Landed";
    case "NO":
      return "Not Operational";
    case "R":
      return "Redirected";
    case "S":
      return "Scheduled";
    case "U":
      return "Unknown";
    default:
      return code;
  }
}





  return (
    <article className="flight-card">



      


      <header className="header">
        {
          carrier_code &&  <div className="airline-badge">{carrier_code}</div>
       }
        <div className="title">
          <h1>
            {carrier_name} • {carrier_code} {flight_number}
          </h1>
          <span className="muted">
            {aircraft_name} {
              flight_equipment_iata ? `(${flight_equipment_iata})` : ""
            } 
          </span>
        </div>

        {
          viewMore && flight?.flight_id && <button className="view-more-btn" onClick={()=>handleViewMore(flight)}>View More </button>
        }
        
        <span className="status-chip">
          <span className="status-dot" />
          {getFlightStatus(status)}
          {arrivalStatus ? ` · ${arrivalStatus}` : ""}
        </span>
      </header>

      <section className="content">
        <div className="route">
          <div className="ap">
            {departure_airport && <div className="code">{departure_airport}</div>}
            <div className="city">
              {departure_city}, {departure_country}
            </div>
            <div className="meta">
            {departure_terminal && <span>T{departure_terminal}</span>}  
             {departure_time && <span>{fmt(departure_time)}</span>}
            </div>
          </div>

          <div className="plane">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z" />
            </svg>
          </div>

          <div className="ap" style={{ textAlign: "right" }}>
            <div className="code">{arrival_airport}</div>
            <div className="city">
              {arrival_city}, {arrival_country}
            </div>
            <div className="meta" style={{ justifyContent: "flex-end" }}>
             {arrival_terminal && <span>T{arrival_terminal}</span>} 
             {(actual_arrival || estimated_arrival || arrival_time) && <span>{fmt(actual_arrival || estimated_arrival || arrival_time)}</span> } 
            </div>
          </div>
        </div>

        <div className="details">
          <div className="flight-row">
            <div>
              <div className="label">Carrier</div>
             {carrier_name ? <div className="value">{carrier_name}</div> :"N/A"} 
            </div>
            <div>
              <div className="label">Flight #</div>
             {flight_number ?  <div className="value">{flight_number}</div>:"N/A"}
            </div>
            <div>
              <div className="label">Region</div>
             {region ? <div className="value">{region}</div> :"N/A"} 
                      </div>
                      
                        <div>
              <div className="label">Scheduled Arrival</div>
             {arrival_time ?  <div className="value">{fmt(arrival_time)}</div>:"N/A"}
            </div>
            <div>
              <div className="label">Actual Arrival</div>
             {(actual_arrival || estimated_arrival) ?  <div className="value">{fmt(actual_arrival || estimated_arrival)}</div> : 'N/A'}
            </div>
            <div>
              <div className="label">Variance</div>
             { arrivalStatus ? <div className="value">{arrivalStatus}</div> : "N/A"}
            </div>
          </div>

          {/* <div className="row">
          
          </div> */}
        </div>
      </section>
    </article>
  );
}
